import React from "react";
import { ReactComponent as Error } from "../assets/icons/error.svg";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary capturó un error:", error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex flex-col items-center justify-center text-center min-h-screen space-y-6 p-6 text-[#313235] font-telefonica">
          <Error />
          <span className="text-md">
            ¡Ups! Ocurrió un error inesperado, por favor vuelve a intentar
          </span>
          <button
            type="button"
            onClick={this.handleReload}
            className="bg-[#019DF4] text-white rounded-3xl py-3 px-10 font-telefonica"
          >
            Recargar
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
